export const SHIPMENT_TRANSPORTATION_OBJECTS = {
  DELIVERY: 'shipmentDestinationDetails',
  PICKUP: 'shipmentOriginDetails',
};

export const SHIPMENT_TRANSPORTATION_TYPES = {
  [SHIPMENT_TRANSPORTATION_OBJECTS.PICKUP]: 1,
  [SHIPMENT_TRANSPORTATION_OBJECTS.DELIVERY]: 2,
};

export const SHIPMENT_TRANSPORTATION_TYPES_ID = {
  1: 'PICKUP',
  2: 'DELIVERY',
};

export const SHIPMENT_TRANSPORTATION_ADDITIONAL_INFO_POST = {
  DELIVERY: 'shipmentDestinationInformation',
  PICKUP: 'shipmentOriginInformation',
};

export const SHIPMENT_FILTER_DATES_FIELDS = ['ExpShipFrom', 'ExpShipTo', 'CreatedDateFrom', 'CreatedDateTo'];

export const QUOTE_SEARCH_FILTER_DATES_FIELDS = [
  'expectedShipFromDate',
  'expectedShipTodate',
  'spotQuoteCreatedFrom',
  'spotQuoteCreateTo',
];

export const DRAFT_ORDER_SEARCH_DATE_FIELDS = ['createdOnFrom', 'createdOnTo'];

export const VISIBILITY_DATE_FIELDS = ['createdonFromDate', 'createdonToDate', 'pickupFromDate', 'pickupToDate'];

export const PROCUREMENT_PROJECT_DATE_FIELDS = ['fromStartDate', 'endStartDate', 'fromEndDate', 'endEndDate'];
export const PROCUREMENT_TENDER_DATE_FIELDS = [
  'tenderStartFromDate',
  'tenderStartToDate',
  'tenderEndFromDate',
  'tenderEndToDate',
];

export const ROUTING_GUIDE_FILTER_DATES_FIELDS = ['ShipmentDate'];

export const SHIPMENT_STATUS_FOR_REASONS = ['Cancelled', 'Hold'];
export const SHIPMENT_STATUS_VALIDATION_FOR_HOLD = ['Cancelled', 'In-Transit'];
export const SHIPMENT_STATUS_VALIDATION_FOR_AUTO_ROUTE = [
  'Tender',
  'Auto-Tendered',
  'In-Transit',
  'Confirmed',
  'Closed',
];

export const SHIPMENT_STATUS_VALIDATION_FOR_NEW_AND_PLANNING = ['Tender', 'Auto-Tendered', 'In-Transit', 'Confirmed'];

export const SHIPMENT_STATUS_VALIDATION_FOR_CANCELLED = [
  'Tender',
  'Auto-Tendered',
  'In-Transit',
  'Confirmed',
  'Hold',
  'Planning',
];

export const SHIPMENT_STATUS_VALIDATION_FOR_CLOSED = ['Tender', 'Auto-Tendered', 'In-Transit', 'Confirmed'];

export const SHIPMENT_STATUS_ALLOWED_STATUS_FOR_CONFIRMED = ['Tender', 'Auto-Tendered'];

export const SHIPMENT_STATUS_ALLOWED_STATUS_FOR_RATE_ERROR = ['New', 'Spot Bid', 'SpotBidEnd'];

export const DIM_UOM_TYPES = {
  CM: 'C',
  INCHES: 'N',
};
